import { SortableCollection } from "../../collections/sortable-collection";
import { IDocumentModel } from "../../interfaces/document-model";
import { ITabDefinition } from "../../interfaces/tab-definition";
import { ListTabModel } from "../tabs/list-tab";
import {BaseRelationModel} from "../../models/base-relation";
import {prop} from "../../../decorators/property";

/**
 * Shows Cited documents from any sector that hasn't already been displayed explicitly as a tab
 */
export class MiscRelationsTabModel extends ListTabModel {

    public constructor(properties: ITabDefinition, data: IDocumentModel, private collectionNamesToCheck: string[]) {
        super(properties, data);
        this.setDocumentData(data); // This is called in superclass constr. But it won't work as the collectionNamesToCheck variable won't have been assigned
        // It looks like it should be as its in done inline in the constructor definition but it doesn't actually work like that.
    }

    public setDocumentData(data: IDocumentModel) {
        if (!this.collectionNamesToCheck) {
            return;
        }
        this.Data = data;
        const toAdd = new Backbone.Collection<BaseRelationModel>();
        _.each(this.collectionNamesToCheck, (name) => {
                toAdd.add(this.safeGetCollectionByName(name));
            });
        if (!this.RelationCollection) {
            this.RelationCollection = new SortableCollection<BaseRelationModel>(this.Sorters, toAdd.models);
        } else {
            this.RelationCollection.reset(toAdd.models);
        }

    }

    private safeGetCollectionByName(name: string) {
        if (this.Data && this.Data[name] && this.Data[name].length > 0) {
            return this.Data[name];
        }
        return [];
    }
}



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./src/desktop/models/tabs/misc-relations.ts